import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Form, Button, FormControl, Table } from "react-bootstrap";
import { LuPenLine, LuPlus, LuTrash2 } from "react-icons/lu";
import { Link, useParams, useLocation } from "react-router-dom";
import API from "../../../services/axiosInstance"
import Pagination from '../../common_modules/pagination';
import FilterBar from '../../common_modules/filter';
import { FormLoader, useFormLoader } from "../../common_modules/loader";
import Permission from '../../security/permission';
import { AUTH_CODE } from '../../security/authCodes';
import { SearchIcon } from '../../common_modules/commonIcons';

const InstreamAdList = () => {
    const [instreamAdList, setInstreamAdList] = useState([]);
    const [paginationData, setPaginationData] = useState({});
    const [searchConfig, setSearchConfig] = useState({});
    const [publisherName, setPublisherName] = useState("");

    const location = useParams();
    const accId = location?.id;
    const accGuid = location?.guid;
    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook loader

    const tableFields = [
        { label: "ID", value: "id", enableSorting: true, enableIcon: true },
        { label: "Title", value: "title", enableSorting: true, enableIcon: true },
        { label: "Status", value: "status", enableSorting: false, enableIcon: false },
        { label: "Ad Format", value: "adFormat", enableSorting: false, enableIcon: true },
        { label: "Ad Size", value: "adSize", enableSorting: false, enableIcon: true },
        { label: "Generation Type", value: "generationType", enableSorting: false, enableIcon: true }
    ];

    const showAdList = async (search, page, field = "", order = "") => {
        startLoading();
        try {
            const size = 10;
            const res = await API.get(`/publisher/instream/ad/setup/list/${accId}?search=${search}&page=${page}&size=${size}&field=${field}&order=${order}`);
            // const data = instreamAdList?.data?.data;
            // if (data?.content) {
            //     setInstreamAdList(data?.content);
            //     setPaginationData(data);
            //     console.log(instreamAdList?.data);
            // }
            const data = res?.data?.data?.content;
            setPublisherName(res?.data?.name);

            if (res.status === 200 && data) {
                setInstreamAdList(data);
                // save pagination information
                let pagination = res.data.data;
                delete pagination.content; //  remove data
                setPaginationData(pagination);
            } else {
                setInstreamAdList([]);
                setPaginationData({});
            }
        } catch (error) { }
        finally {
            stopLoading();
        }
    }

    // Delete ad setUp
    const deleteAdSetUp = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this Ad Setup?");
        if (!confirmDelete) return;
        try {
            const res = await API.delete(`/publisher/instream/ad/setup/delete/${id}`);
            console.log(res.data.status);
            if (res?.data?.status === "Success") {
                alert("Ad deleted successfully");
                showAdList("", 0);
            } else {
                alert("Something went wrong");
            }
        } catch (error) {
            console.error("Delete error:", error);
        }
    }

    const nextPage = (nextPage) => {
        showAdList("", nextPage, searchConfig?.orderField, searchConfig?.orderDir)
    }



    const onChangeSearch = (params) => {
        setSearchConfig(params)
        showAdList(params.keyword, 0, params.orderField, params.orderDir); // API call
    }

    useEffect(() => {
        if (accGuid) {
            showAdList("", 0);
        }
    }, [accGuid])

    return (
        <>
            <FormLoader isLoading={isLoading} text={"Loading..."}>
                <div className="breadCrumb gradient-bg">
                    <Link to={'/dashboard'}><span>Home</span></Link>
                    <Permission code={AUTH_CODE.accounts.publisherListing}>
                        <Link to={'/active-publisher'}><span>Publisher</span></Link>
                    </Permission>
                    {/* <span>{publisherName}</span> */}
                    <Link to={`/publisher/info/${accId}/${accGuid}`}><span>{publisherName}</span></Link>
                    <span>Manage Instream Ad</span>
                    {/* <span>{accId}</span> */}
                </div>
                <h6 className="title mb-4 mt-4">Ad Setup List</h6>
                <Card className='p-2 mb-2'>
                    <div className="filter row">
                        <Link to={`/publisher/add-instream-ad/${accId}/${accGuid}`} style={{ color: "#ffffff" }}>
                            <Permission code={AUTH_CODE.instreamAdSetup.createInstreamAd}>
                                <Button variant="primary" className="addBtn">
                                    Create Instream Ad <LuPlus />
                                </Button>
                            </Permission>
                        </Link>
                        <FilterBar fields={tableFields} onSearch={onChangeSearch} />
                    </div>
                    <div className="mt-0 table-wrapper mt-3">
                        {/* <div className="table-scroll"> */}
                        <Table striped bordered responsive hover size="sm" className="custom-table align-middle">
                            <thead>
                                <tr>
                                    <th>☰</th>
                                    {
                                        tableFields?.map((item, i) => (
                                            <th key={i}>
                                                {item.label}
                                                {item.enableIcon ? <SearchIcon className="ms-1" size={10} fill="white" /> : ""}
                                            </th>
                                        ))
                                    }
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    instreamAdList?.length > 0 ?
                                        instreamAdList?.map((adList, index) => (
                                            <tr key={index}>
                                                <td>{(paginationData.number * paginationData.size) + (index + 1)}</td>
                                                <td>{adList?.id}</td>
                                                <td>{adList?.title}</td>
                                                <td style={{ textAlign: "center" }}>
                                                    <span className={`badge ${adList?.status === 1 ? "active" : "inactive"}`}>
                                                        {adList?.status === 1 ? "Active" : "Inactive"}
                                                    </span>
                                                </td>
                                                <td>{adList?.adFormat}</td>
                                                <td>{adList?.adSize}</td>
                                                <td>{adList?.generationType}</td>
                                                <td>
                                                    <div className="d-flex gap-2 flex-nowrap activePubAllBtns justify-content-center">
                                                        <Permission code={AUTH_CODE.instreamAdSetup.updateInstreamAd}>
                                                            <Link to={`/publisher/edit/instream-ad/${adList?.id}/${adList?.accountId}/${adList?.accountGuid}`}>
                                                                <button> Edit <LuPenLine /> </button>
                                                            </Link>
                                                        </Permission>
                                                        <Permission code={AUTH_CODE.instreamAdSetup.deleteInstreamSetting}>
                                                            <button onClick={() => deleteAdSetUp(adList?.id)}> Delete Adsetup <LuTrash2 /></button>
                                                        </Permission>
                                                    </div>
                                                </td>
                                            </tr>
                                        )) : <tr><td colSpan="13" style={{ textAlign: "center" }}>No Data available</td></tr>
                                }
                            </tbody>
                        </Table>
                        {/* </div> */}
                    </div>
                </Card>
                <Pagination
                    jumpPage={true}
                    count={true}
                    component={InstreamAdList.name}
                    size={"sm"}
                    paginationData={paginationData}
                    nextPage={nextPage} />
            </FormLoader>
        </>
    )
}

export default InstreamAdList;